<template>
  <p class="w-64 space-y-2">
    <NSkeleton as="span" class="block h-3 w-full" />
    <NSkeleton as="span" class="block h-3 w-2/3" />
  </p>
</template>
